<div *ngIf="printer.showMeReport" id="viewerContent"></div>

<app-kontable
    #activeReservationTable
    title="{{ 'reservations.activeReservations' | translate }}"
    [columns]="[
      {field: 'num_reservation', title: 'reservations.reservationNumber'},
      {field: 'dt_reservation', title: 'reservations.reservationDate', type: 'date', filterType: dateFilter},
      {field: 'gift_code', title: 'reservations.gift', bodyTemplate: giftTemplate},
      {field: 'points', title: 'reservations.points'},
      {field: 'value', title: 'reservations.contribution', bodyTemplate: contribution},
      {field: 'status', title: 'reservations.status'},
      {field: 'barcode', title: 'reservations.barcode'},
      {field: 'store_desc', title: 'common.store_title', bodyTemplate: storeTemplate},
      {field: 'pickup_store_desc', title: 'reservations.pickupStore', bodyTemplate: pickupStoreTemplate},
      {field: 'dt_assigned', title: 'reservations.dateAssigned', type: 'date', filterType: dateFilter}
    ]"
    [source]="reservations"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [showReport]="true"
    [showGlobalFilter]="false"
    [additionalRowCommands]="customRow"
  >
    <!-- Custom Buttons -->
    <ng-template #customRow data-testid="customRow" let-row>
      <!-- Button Invio -->
      <p-button
        *ngIf="row.status.toUpperCase() === 'PRENOTATO' || row.status.toUpperCase() === 'PRONTO'"
        pTooltip="{{ 'reservations.sendToCustomer' | translate }}"
        icon="fa fas fa-paper-plane-o"
        styleClass="ui-button-info"
        (click)="sendEmail(row)">
      </p-button>
      <!-- Button Stampa  -->
      <p-button
        *ngIf="(row.status.toUpperCase() === 'PRENOTATODAPAGARE' || row.status.toUpperCase() === 'PRONTO') && row.operability == '1'"
        pTooltip="{{ 'reservations.printPaymentForm' | translate }}"
        icon="fa fas fa-print"
        styleClass="ui-button-info"
        (click)="showPrintPopUp(row)">
      </p-button>
      <!-- Button Conferma Ritiro Premio -->
      <p-button
        *ngIf="(row.status.toUpperCase() === 'PAGATO' || row.status.toUpperCase() === 'PRONTO') && row.operability === '1'"
        pTooltip="{{ 'reservations.confirmPickup' | translate }}"
        icon="fa fas fa-archive"
        styleClass="ui-button-info"
        (click)="pickupGift(row.id)"
      ></p-button>
      <!-- Button Annulla -->
      <p-button
        *ngIf="(row.status.toUpperCase() === 'PRENOTATO' || row.status.toUpperCase() === 'PRENOTATODAPAGARE') && row.operability === '1'"
        pTooltip="{{ 'common.cancel' | translate }}"
        icon="fa fas fa-trash"
        styleClass="ui-button-info"
        (click)="confirmCancelReservation(row)">
      </p-button>
      <!-- Button Upload Fattura -->
      <!--
        NOTA:
        è da aggiungere la condizione di "prenotazione online"
      -->
      <p-button
        *ngIf="customerPermissions.customerMg &&
        row.flg_source_reserv === '1' &&
        (row.param_key === 'DEL.EMAIL.SMS' || row.param_key === 'DEL.ADDRESS' || (row.param_key === 'DEL.PDV.ADDRESS' && row.flg_pickup_store===null)) &&
        row.value > 0"
        pTooltip="{{ 'reservations.invoices' | translate }}"
        icon="fa fa-file"
        styleClass="ui-button-info"
        (click)="onClickFatturePremi(row)">
      </p-button>


      <!-- Button Visualizzazione Dettagli Prenotazione -->
      <p-button pTooltip="{{ 'common.view' | translate }}" icon="fa fas fa-eye" styleClass="ui-button-info" (onClick)="onShowDetails.emit(row)"></p-button>
    </ng-template>

    <!-- Template Premio -->
    <ng-template #giftTemplate data-testid="giftTemplate" let-row>
      <span>{{ row.gift_code }} - {{ row.gift_description }}</span>
    </ng-template>
    <!-- Template Negozio -->
    <ng-template #storeTemplate data-testid="storeTemplate" let-row>
      <span>{{ row.store_host_code }} - {{ row.store_desc }}</span>
    </ng-template>
    <!-- Template Negozio Ritiro -->
    <ng-template #pickupStoreTemplate data-testid="pickupStoreTemplate" let-row>
      <span>{{ row.pickup_store_host_code }} - {{ row.pickup_store_desc }}</span>
    </ng-template>

    <!-- Template contributo-->
    <ng-template #contribution data-testid="contribution" let-row>
      <span *ngIf="row.value">{{row.value.toFixed(2)  + "€"}}</span>
    </ng-template>
  </app-kontable>


  <p-dialog *ngIf="show.modalFatturePremi" header="{{ 'reservations.invoices' | translate }}" [(visible)]="show.modalFatturePremi" [modal]="true" [minWidth]="800" [draggable]="true" position="top">
      <app-upload-mg-fatture-premi
      *ngIf="show.modalFatturePremi"
      [codice_cliente]="modalFatturePremi.codice_cliente"
      [name]="modalFatturePremi.name"
      [surname]="modalFatturePremi.surname"
      [num_reservation]="modalFatturePremi.num_reservation"
      [card_no]="modalFatturePremi.card_no"
      [customerId]="modalFatturePremi.customerId"
      [permissions]="resCustomerPermissions"
      [reqDownloadPermission]="reqDownloadInvoicesPermission"
      [reqUploadPermission]="reqUploadInvoicesPermission"
    ></app-upload-mg-fatture-premi>
  </p-dialog>




// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservations/loyalty-active-reservations/loyalty-active-reservations.component.html